export const user = JSON.parse(localStorage.getItem('authUser'))

export const userRoles = {
    admin: "Admin",
    assessor: "assessor",
    student: "student"
}